import TranslateFood from "@/views/admin/translate/TranslateFood";

export default {
  path: "translate/food",
  name: "TranslateFood",
  component: TranslateFood,
  props: true,
  meta: {
    requiresAuth: true,
    owner: true
  }
};
